export default __webpack_public_path__ + "static/media/pc05-2.9f18c6e2.png";